export const MODAL_TITLE = 'Manage your saved search list';
export const EMPTY_FILTERS_LIST = `Currently, you don't have any saved search.`;